"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SETTINGS_NAMES = void 0;
var SETTINGS_NAMES = exports.SETTINGS_NAMES = {
  INITIAL_CURRENCY_CODE: 'INITIAL_CURRENCY_CODE',
  IS_DISABLE_SEARCH: 'IS_DISABLE_SEARCH',
  ENABLE_ADVERTISE_FOR_OPERATORS_FORCE: 'ENABLE_ADVERTISE_FOR_OPERATORS_FORCE',
  ENABLED_MT_2_STRATEGY_FOR_OPENING_OFFER_DETAIL_MODAL: 'ENABLED_MT_2_STRATEGY_FOR_OPENING_OFFER_DETAIL_MODAL',
  ENABLED_SIMPLIFY_BOOKING_REDIRECT: 'ENABLED_SIMPLIFY_BOOKING_REDIRECT',
  DISABLED_BOOKING_PAYER_EMAIL_CONTROL: 'DISABLED_BOOKING_PAYER_EMAIL_CONTROL',
  DISABLED_ADVERTISE_FOR_OPERATORS: 'DISABLED_ADVERTISE_FOR_OPERATORS',
  DISABLED_BOOKING_CONDITION_CONTROL: 'DISABLED_BOOKING_CONDITION_CONTROL',
  DISABLED_BOOKING_OPERATORS_CONTROL: 'DISABLED_BOOKING_OPERATORS_CONTROL',
  DISABLED_BOOKING_PHONE_CONTROL: 'DISABLED_BOOKING_PHONE_CONTROL',
  MODE: 'MODE',
  ENABLED_OPERATORS_FOR_FOSTER_API: 'ENABLED_OPERATORS_FOR_FOSTER_API',
  ANALYTICS_PAYLOAD: 'ANALYTICS_PAYLOAD',
  ENABLED_BOOKING_SERVICES: 'ENABLED_BOOKING_SERVICES',
  INITIAL_IS_COMPACT_RESULTS_VIEW: 'INITIAL_IS_COMPACT_RESULTS_VIEW',
  GOOGLE_PUBLISH_TAGS: 'GOOGLE_PUBLISH_TAGS',
  ENABLED_HOTEL_DESCRIPTION_BY_AI: 'ENABLED_HOTEL_DESCRIPTION_BY_AI'
};